document.addEventListener('click',function(e){const link=e.target.closest('a');if(!link)return;if(link.dataset.species){const select=document.getElementById('inquiry-species');if(select)select.value=link.dataset.species;}if(link.closest('.mobile-nav'))link.closest('.mobile-nav').removeAttribute('open');});document.addEventListener('DOMContentLoaded',function(){const heading=document.querySelector('.species-hero h1');const select=document.getElementById('inquiry-species');if(heading&&select)select.value=heading.textContent.trim();});
(function(){
  function init(){
    var header=document.getElementById('shopify-section-ranch-header');
    if(!header||header.dataset.scrollHeaderReady)return;
    header.dataset.scrollHeaderReady='true';
    header.classList.add('ranch-sticky-header');
    var previous=Math.max(0,window.scrollY),pending=false,height=header.offsetHeight;
    function measure(){height=header.offsetHeight;document.documentElement.style.setProperty('--ranch-header-height',height+'px');}
    function show(){header.classList.remove('is-hidden');}
    function update(){
      pending=false;
      var y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-window.innerHeight));
      var change=y-previous;
      header.classList.toggle('is-scrolled',y>8);
      var focused=header.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');
      if(y<=height||header.querySelector('.mobile-nav[open]')||focused){show();previous=y;return;}
      if(Math.abs(change)<8)return;
      header.classList.toggle('is-hidden',change>0);
      previous=y;
    }
    measure();
    if(window.ResizeObserver)new ResizeObserver(measure).observe(header);
    else window.addEventListener('resize',measure);
    window.addEventListener('scroll',function(){if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});
    header.addEventListener('focusin',show);
    header.addEventListener('toggle',function(event){if(event.target.open)show();},true);
    window.addEventListener('pageshow',function(){previous=Math.max(0,window.scrollY);show();});
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
